// extracted by mini-css-extract-plugin
export default {"category":"Category_category__se62M","overlay":"Category_overlay__tu8R9","withColor":"Category_withColor__Ww9Jg","changePos":"Category_changePos__+LSsE"};